
<div class="page-body">
    <h1 data-aos="fade-down" data-aos-duration="800">Volta</h1>
    <div class="info">
        <p><strong>Context</strong><br>Game Design Project</p>
        <p><strong>Team</strong><br>Molly Fleming, Rebecca Henry</p>
        <p><strong>Role</strong><br>User Experience, Concept Ideation, Asset Creation & Scene Development</p>
        <p><strong>Tools</strong><br>Adobe Illustrator, Unity</p>
    </div>
    <img class="full-screen" src="assets/projects/volta/voltaspread.png">
    <h2>Brief</h2>
    <div class="brief">
        <img src="assets/projects/volta/voltaBrief.jpg">
    </div>

    <h3>Listen.</h3>
    <h4>Game overview</h4>
    <p>Some feelings and moods can be easily described in one language but not in another. The game concept of Volta combines exploration and wonder as the player collects pieces of a word that are untranslatable in English while walking through a scene and solving puzzles that relate to the word definition.</p>
    
    <h3>Reshape.</h3>
    <h4>An intuitive play experience</h4>
    <p>The gameplay of Volta can be summarized as a puzzle-based platformer.</p>
    <img class="centered" src="assets/projects/volta/main screen.jpg">

    <p>The game fades into an opening scene of the English description of a foreign word.</p>
    <img class="centered" src="assets/projects/volta/leveloneintro.jpg">


    <p>The player then finds themself in a platform scene inspired by the description of the word, where they can move around with the asdw controls. The player collects letters of the word upon contact, collecting each letter in the word until the word is complete. Collecting letters may require solving puzzles, such as finding hidden letters or completing tasks related to the definition prompt. The player navigates through the level by jumping onto platforms, avoiding cliffs and other obstacles. </p>


    <img class="centered" src="assets/projects/volta/level 1.jpg">

    <p>As soon as the letters are collected, the foreign word is revealed and the next level begins.</p>

    <img class="centered" src="assets/projects/volta/leveloneend.jpg">
    <img class="centered" src="assets/projects/volta/leveltwointro.jpg">

    <p>The later levels increase in puzzle difficulty as the player gets accustomed to the game world. The player needs to reflect on their everyday habits for the second level and reveal letters by doing small things that might bring joy everyday. The process of solving the puzzle allows players to engage in mindful practices while learning the untranslatable word through an experience rather than a definition </p>
    <img class="centered" src="assets/projects/volta/leveltwo.jpg">
    <img class="centered" src="assets/projects/volta/leveltwoend.jpg">

    <h3>Design.</h3>
    <h4>Inclusive character design</h4>
    <p>The main character has an ambiguous design. It has a human-like form, but no qualities such as gender, age, or race which allows the player to project themself onto it. It looks like an astronaut, which complements the explorer style of player.</p>
    <img class="centered" src="assets/projects/volta/character.jpg">

    <h4>Clean and Abstract Interface Assets</h4>
    <p>The assets use a flat vector style, which is very flexible in terms of design and is used for all assets.</p>

    <h4>Planning Process and Testing</h4>
    <p>We outline main goals in documentation before moving on to visual planning (on Adobe Illustrator). After a level is complete, we conduct play testing to improve our design implementations.</p>

    <h3>Play!</h3>
    <p>The project is in progress with 5 levels planned so far.</p>
    <p>Try playing the first two levels of the game. Likes are always appreciated and any comment will be helpful for improving our game!</p>
    <iframe id='webgl_iframe' frameborder="0" allow="autoplay; fullscreen; vr" allowfullscreen="" allowvr="" mozallowfullscreen="true" src="https://play.unity3dusercontent.com/webgl/e7bd54f9-44e1-4341-9668-6d60391a7fe9?screenshot=false&embedType=embed" width="810" height="640" onmousewheel="" webkitallowfullscreen="true"></iframe>

    <a class="next" routerLink="/compsa">Next work -></a>
</div>
